import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable, signal } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/modules/user/user';
import { catchError, map, Observable, of, switchMap, throwError } from 'rxjs';
import { authCodeFlowConfig } from './auth.config';
//import { JwtHelperService } from '@auth0/angular-jwt';
@Injectable({providedIn: 'root'})
export class AuthService
{
    private _authenticated: boolean = false;
    private _httpClient = inject(HttpClient);
    private _userService = inject(UserService);
    userName: any;
    roles = signal<string[]>([]); // Holds the roles
    currentUser = signal<User | null>(null); // Holds the current user
    userId: number;
    regionId: number;
    private _jwtHelper = new JwtHelperService();

    constructor(private oauthService: OAuthService, private config: AuthConfig) {
        this.initRoles();
        this.initUserId();
        this.authName();
    }
    
    initRoles() {
        const decodedToken = this._jwtHelper.decodeToken(this.oauthService.getAccessToken());
        const role = decodedToken?.roles;
        return Array.isArray(role) ? role : [role];
        // this.oidcSecurityService.getAccessToken()
        //     .pipe(
        //         map((token) => {
        //             // Decode the token and extract roles
        //             const decodedToken = this._jwtHelper.decodeToken(token);
        //             const role = decodedToken?.roles;
        //             return Array.isArray(role) ? role : [role];
        //         })
        //     )
        //     .subscribe((roles) => {
        //         this.roles.set(roles); // Update the roles signal
        //     });
    }

    logout(){
        debugger
        this.oauthService.logOut();
    }

    initUserId(): Observable<string> {
        // return this.oidcSecurityService.getAccessToken().pipe(
        //     map((token) => {
        //         // Decode the token and extract userId
        //         const decodedToken = this._jwtHelper.decodeToken(token);
        //         const userId = decodedToken?.sub;
        //         this.userId = +userId;
        //         return userId;
        //     })
        // );
        const decodedToken = this._jwtHelper.decodeToken(this.oauthService.getAccessToken());
        const userId = decodedToken?.sub;
        this.userId = +userId;
        return userId;
    }  
    
    authName():void{
        const decodedToken = this._jwtHelper.decodeToken(this.oauthService.getAccessToken());
        this.userName = decodedToken?.name;
        return this.userName;
    }  

    authRegion(): Observable<number> {
        // return this.oidcSecurityService.getAccessToken().pipe(
        //     map((token) => {
        //         // Decode the token and extract userId
        //         const decodedToken = this._jwtHelper.decodeToken(token);
        //         this.regionId = decodedToken?.region;
        //         return this.regionId;
        //     })
        // );
        const decodedToken = this._jwtHelper.decodeToken(this.oauthService.getAccessToken());
        this.regionId = decodedToken?.region;
        return of(this.regionId);
    }  

    // Computed property for accessing roles
    rolesComputed = computed(() => this.roles());

    get isLoggedIn() {
        // return this.oidcSecurityService.isAuthenticated$;
        // return this.oidcSecurityService.isAuthenticated$.subscribe(
        //     ({ isAuthenticated }) => {
        //         this._authenticated = isAuthenticated
        //     }
        // );
        return this.oauthService.hasValidAccessToken();
        return true;
    }

    get token() {
        // return this.oidcSecurityService.getToken();
        // return this.oidcSecurityService.getAccessToken().subscribe((token) => {
        //     token
        // });
        return this.oauthService.getAccessToken();
    }

    get identityClaims(): any {
        return this.oauthService.getIdentityClaims();
      }

    get userData() {
        // return this.oidcSecurityService.userData$;
        return null;
    }

    checkAuth() {
        // return this.oidcSecurityService.checkAuth();
        return true;
    }

    doLogin() {
        debugger
        // return of(this.oidcSecurityService.authorize());
        this.oauthService.configure(authCodeFlowConfig);
        this.oauthService.loadDiscoveryDocumentAndTryLogin();
        this.oauthService.initLoginFlow();
    }

    signOut() {
        this.oauthService.logOut();
    }

    //private _jwtHelper = new JwtHelperService();
    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string)
    {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('accessToken') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Forgot password
     *
     * @param email
     */
    forgotPassword(email: string): Observable<any>
    {
        return this._httpClient.post('api/auth/forgot-password', email);
    }

    /**
     * Reset password
     *
     * @param password
     */
    resetPassword(password: string): Observable<any>
    {
        return this._httpClient.post('api/auth/reset-password', password);
    }

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(credentials: { email: string; password: string }): Observable<any>
    {
        // Throw error, if the user is already logged in
        if ( this._authenticated )
        {
            return throwError('User is already logged in.');
        }

        return this._httpClient.post('api/auth/sign-in', credentials).pipe(
            switchMap((response: any) =>
            {
                // Store the access token in the local storage
                this.accessToken = response.accessToken;

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return a new observable with the response
                return of(response);
            }),
        );
    }

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {
        // Sign in using the token
        return this._httpClient.post('api/auth/sign-in-with-token', {
            accessToken: this.accessToken,
        }).pipe(
            catchError(() =>

                // Return false
                of(false),
            ),
            switchMap((response: any) =>
            {
                // Replace the access token with the new one if it's available on
                // the response object.
                //
                // This is an added optional step for better security. Once you sign
                // in using the token, you should generate a new one on the server
                // side and attach it to the response object. Then the following
                // piece of code can replace the token with the refreshed one.
                if ( response.accessToken )
                {
                    this.accessToken = response.accessToken;
                }

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return true
                return of(true);
            }),
        );
    }

    /**
     * Sign out
     */
    // signOut(): Observable<any>
    // {
    //     // Remove the access token from the local storage
    //     localStorage.removeItem('accessToken');

    //     // Set the authenticated flag to false
    //     this._authenticated = false;

    //     // Return the observable
    //     return of(true);
    // }

    /**
     * Sign up
     *
     * @param user
     */
    signUp(user: { name: string; email: string; password: string; company: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/sign-up', user);
    }

    /**
     * Unlock session
     *
     * @param credentials
     */
    unlockSession(credentials: { email: string; password: string }): Observable<any>
    {
        return this._httpClient.post('api/auth/unlock-session', credentials);
    }

    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

        // Check the access token availability
        if ( !this.accessToken )
        {
            return of(false);
        }

        // Check the access token expire date
        if ( AuthUtils.isTokenExpired(this.accessToken) )
        {
            return of(false);
        }

        // If the access token exists, and it didn't expire, sign in using it
        return this.signInUsingToken();
    }
    // authName(): Observable<string> {
    //     return this.oidcSecurityService.getAccessToken().pipe(
    //         map((token) => {
    //             const decodedToken = this._jwtHelper.decodeToken(token);
    //             this.userName = decodedToken.name;
    //             return this.userName;
    //         })
    //     );
    // }  
}
